export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectUserId = (state) => state.user.userId;
export const selectUserCourses = (state) => state.user.courses;
export const selectCurrentWorkout = (state) => state.user.currentWorkout;
export const selectUserEmail= (state) => state.user.email;
